import styled from 'styled-components/macro';
import { BotDialogPillsList } from 'components/BotDialog/BotDialog.styles';

export const List = styled(BotDialogPillsList)`
  list-style: none;
  margin: 0;
  padding: 0;
`;
